import React from 'react';
import { IBannerSlider } from './BannerSlider.interface';
import styles from './BannerSlider.module.scss';
import { Button } from '@toctoc/design-system';

interface IBannerRenderwProps {
	banner: IBannerSlider
}

export const Banner = ({ banner }: IBannerRenderwProps) => {
	if(banner === null || banner === undefined || Object.keys(banner).length === 0 ) return null
	const { titulo, texto, img, url } = banner;
	const { src, alt } = img ?? {}
	return (
		<article className={styles.cBannerSlider}>
			{
				src &&
				<div className={styles.cImg}>
					<img className={styles.imgSlider} src={src} alt={alt} />
				</div>
			}
			<div className={styles.cTextoSlider}>
				<div>
					<p className={styles.tituloSlider}>{titulo}</p>
					<p className={styles.textoSlider}>{texto && texto}</p>
				</div>
				<div className={styles.cBoton}>
					{url && <Button
						color="primary"
						href={url}
						size="medium"
						texto="Ver más"
						variant="outlined"
						fullWidth={true}
					/>
					}
				</div>
			</div>
		</article>
	);
};